import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';

function getDiscountInformationAsSentence({ partner, payment }) {
    switch (payment.performedBy) {
        case 'BUYER':
            return `${partner.name} har godtatt å få et prisavslag på ${formatOreToKroner(
                payment.discount
            )}.`;
        default:
            return `Du har godtatt et prisavslag på ${formatOreToKroner(
                payment.discount
            )}.`;
    }
}

const DiscountApprovedSummary = ({ partner, payment, withdrawal }) => {
    let actionRequiredType;
    let statusSummary;
    let body;

    if (withdrawal) {
        statusSummary = 'Handelen er ferdig';
        body = getDiscountInformationAsSentence({ partner, payment });
    } else {
        actionRequiredType = 'POSITIVE';
        statusSummary = getDiscountInformationAsSentence({ partner, payment });
        body = 'Få pengene';
    }

    return (
        <StatusSummaryButton
            actionRequiredType={actionRequiredType}
            href="/losning/enighet-om-avslag"
            statusSummary={statusSummary}
        >
            {body}
        </StatusSummaryButton>
    );
};

DiscountApprovedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

export default DiscountApprovedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/summaries/discountApprovedSummary.jsx